var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#fff1f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 45,
    width: 60,
    height: 170,
    rx: 30,
    fill: "white",
    stroke: "#f43f5e",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 130,
    width: 60,
    height: 85,
    rx: 30,
    fill: "#fecdd3",
    opacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 160,
    width: 60,
    height: 55,
    rx: 30,
    fill: "#f43f5e",
    opacity: 0.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 35,
    width: 46,
    height: 18,
    rx: 5,
    fill: "#f43f5e",
    opacity: 0.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 180,
    r: 7,
    fill: "#f43f5e",
    opacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 172,
    r: 5,
    fill: "#f43f5e",
    opacity: 0.12
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 192,
    r: 4,
    fill: "#f43f5e",
    opacity: 0.12
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 262,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#9f1239"
  }, "Kan Alma")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodTest);
export default __webpack_public_path__ + "static/media/blood-test.d809b6157d2134eec4977af10f79c306.svg";
export { ForwardRef as ReactComponent };